import { getLanguageName } from './languages';

// supported_browser_languages
const SUPPORTED_LANGUAGES = {
  af: getLanguageName('af'),
  ar: getLanguageName('ar'),
  bg: getLanguageName('bg'),
  bn: getLanguageName('bn'),
  ca: getLanguageName('ca'),
  cs: getLanguageName('cs'),
  cy: getLanguageName('cy'),
  da: getLanguageName('da'),
  de: getLanguageName('de'),
  el: getLanguageName('el'),
  en: getLanguageName('en'),
  eo: getLanguageName('eo'),
  es: getLanguageName('es'),
  et: getLanguageName('et'),
  fa: getLanguageName('fa'),
  fi: getLanguageName('fi'),
  fr: getLanguageName('fr'),
  gu: getLanguageName('gu'),
  he: getLanguageName('he'),
  hi: getLanguageName('hi'),
  hr: getLanguageName('hr'),
  hu: getLanguageName('hu'),
  id: getLanguageName('id'),
  it: getLanguageName('it'),
  ja: getLanguageName('ja'),
  jv: getLanguageName('jv'),
  kn: getLanguageName('kn'),
  ko: getLanguageName('ko'),
  lt: getLanguageName('lt'),
  lv: getLanguageName('lv'),
  ml: getLanguageName('ml'),
  mr: getLanguageName('mr'),
  ms: getLanguageName('ms'),
  ne: getLanguageName('ne'),
  nl: getLanguageName('nl'),
  nn: getLanguageName('nn'),
  no: getLanguageName('no'),
  pa: getLanguageName('pa'),
  pl: getLanguageName('pl'),
  pt: getLanguageName('pt'),
  'pt-BR': getLanguageName('pt-BR'),
  ro: getLanguageName('ro'),
  ru: getLanguageName('ru'),
  sk: getLanguageName('sk'),
  sl: getLanguageName('sl'),
  sr: getLanguageName('sr'),
  sv: getLanguageName('sv'),
  ta: getLanguageName('ta'),
  th: getLanguageName('th'),
  tl: getLanguageName('tl'),
  tr: getLanguageName('tr'),
  uk: getLanguageName('uk'),
  ur: getLanguageName('ur'),
  vi: getLanguageName('vi'),
  'zh-Hans': getLanguageName('zh-Hans'),
  'zh-Hant': getLanguageName('zh-Hant'),
};

// Properties: language code (e.g. 'ja')
// Values: name of the language in native form (e.g. '日本語')
export default SUPPORTED_LANGUAGES;
